import { isMixpanelProduction, logMixpanelDevEvent } from "@/lib/mixpanel/devLogger";
import { getMixpanelUserSnapshot } from "@/lib/mixpanel/mixpanelUserSnapshot";

const ANONYMOUS_MIXPANEL_ID_KEY = "anonymous_mixpanel_id";

function getFallbackDistinctId(userProperties: Record<string, unknown>) {
  const email = userProperties.email;
  if (typeof email === "string" && email.trim() !== "") return email;

  if (typeof window === "undefined") return "anonymous";

  const storedId = window.localStorage.getItem(ANONYMOUS_MIXPANEL_ID_KEY);
  if (storedId) return storedId;

  const anonymousId =
    typeof window.crypto?.randomUUID === "function"
      ? window.crypto.randomUUID()
      : `anonymous-${Date.now()}-${Math.random().toString(36).slice(2)}`;

  window.localStorage.setItem(ANONYMOUS_MIXPANEL_ID_KEY, anonymousId);
  return anonymousId;
}

export const fireCustomMixpanelEvent = async (
  eventName: string,
  distinct_id: string | null | undefined,
  insert_id: string,
  options?: {
    [key: string]: unknown;
  },
  explicitUserProperties?: {
    [key: string]: unknown;
  },
) => {
  const userProperties = {
    ...getMixpanelUserSnapshot(),
    ...explicitUserProperties,
  };
  const resolvedDistinctId = distinct_id || getFallbackDistinctId(userProperties);
  const response = await fetch("/api/send-to-mixpanel", {
    method: "POST",
    keepalive: true,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ eventName, distinct_id: resolvedDistinctId, insert_id, options, userProperties }),
  });

  if (isMixpanelProduction) return;

  const data = (await response.json()) as {
    success: boolean;
    payload?: Record<string, unknown>;
  };

  logMixpanelDevEvent("client", eventName, data.payload ?? {
    distinct_id: resolvedDistinctId,
    $insert_id: insert_id,
    ...userProperties,
    ...options,
  });
};
